/**
 * @file 认证案例
 * @author
 */
// @ts-nocheck
import React, {Fragment, useEffect, useRef} from 'react';
import CountUp from 'react-countup';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination, Navigation, Autoplay} from 'swiper';
import 'swiper/components/navigation/navigation.less';
import 'swiper/components/pagination/pagination.less';
import meixinmen from './imgs/meixinmen.png';
import jitusudi from './imgs/jitu.png';
import shuaifeng from './imgs/shuaifeng.png';
import iconNext from './imgs/icon-next.svg';
import iconUp from './imgs/icon-up.svg';
import AuthButton from './authButton';

interface Props {
    title: string;
    match: any;
}

SwiperCore.use([Pagination, Navigation, Autoplay]);
export default function AuthCases(props: Props) {
    const countUpStart = useRef({});
    // const {params = {}} = props.match || {};
    // const isSimple = params.type === 'simple';
    const isSimple = false;
    const displayCard = [
        {
            title: '极兔速递',
            img: jitusudi,
            industry: '快递行业',
            preAuth: '网民搜索快递物流号码需求较大，但信息杂乱，无法识别',
            afterAuth: '提升企业号码曝光，与用户建立高效联系',
            url: 'https://www.baidu.com/s?wd=极兔速递客服',
            num: [{
                label: '提升展示量',
                value: 100
            }, {
                label: '提升点击量',
                value: 100
            }, {
                label: '提升拨打量',
                value: 100
            }]
        },
        {
            title: '美心门',
            img: meixinmen,
            industry: '家居行业',
            preAuth: '网民查找售后维修电话，展示仿冒电话，公司形象受损',
            afterAuth: '展示准确信息，树立品牌形象，提升服务质量',
            url: 'https://www.baidu.com/s?wd=美心门号码',
            num: [{
                label: '提升展示量',
                value: 100
            }, {
                label: '提升点击量',
                value: 100
            }, {
                label: '提升拨打量',
                value: 100
            }]
        },
        {
            title: '帅丰电器',
            img: shuaifeng,
            industry: '家电行业',
            preAuth: '网名搜索电话后展示错误信息，公司信誉受损',
            afterAuth: '展示官方标识，号码权威有保证，建立用户信任',
            /* eslint-disable */
            url: 'https://www.baidu.com/s?wd=帅丰号码',
            /* eslint-enable */
            num: [{
                label: '提升展示量',
                value: 100
            }, {
                label: '提升点击量',
                value: 100
            }, {
                label: '提升拨打量',
                value: 100
            }]
        },
    ];
    const card = item => {
        return (
            <div className="auth-cases-card">
                <img width="280" height="280" src={item.img}></img>
                <div className="case-info">
                    <div className="case-name">
                        <p className="case-title">{item.title}</p>
                        <a
                            className="case-btn"
                            href={item.url}
                            target="_blank" rel="noopener noreferrer"
                        >
                            查看实际效果 <img src={iconNext} className="arrow-icon"></img>
                        </a>
                        {/* <div className="case-btn" onClick={item.url}>查看实际效果<img src={iconNext}/></div> */}
                    </div>
                    <div className="case-tag">{item.industry}</div>
                    <p className="case-desc"><span>认证前：</span>{item.preAuth}</p>
                    <p className="case-desc"><span>认证后：</span>{item.afterAuth}</p>
                    <ul className="case-data">
                        {item.num.map(num => {
                            return (
                                <li key={item.title + num.label}>
                                    <CountUp
                                        start={50}
                                        end={num.value}
                                        duration={1}
                                    >
                                        {({countUpRef, start}) => {
                                            countUpStart.current = {
                                                ...countUpStart.current,
                                                [item.title + num.label]: start
                                            };
                                            return (
                                                <span ref={countUpRef} />
                                            );
                                        }}
                                    </CountUp>
                                    <span>%</span>
                                    <img src={iconUp}/>
                                    <p>{num.label}</p>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    };
    useEffect(() => {
        onCountUpStartFn();
    }, []);
    const onCountUpStartFn = () => {
        return Object.keys(countUpStart.current)
            .map(key => countUpStart.current && countUpStart.current[key]());
    };
    return (
        <Fragment>
            {!isSimple && <div className="auth-cases">
                <p className="common-title title">{props.title}</p>
                <p className="common-subtitle">* 数据统计解释权归百度所有</p>
                <Swiper
                    slidesPerView={1}
                    // autoplay={{
                    //     delay: 3000,
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false
                    // }}
                    className={'auth-cases-swiper-box'}
                    pagination={{
                        // type: 'bullets',
                        el: '.swiper-pagination',
                        clickable: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }}
                    onSlideChange={onCountUpStartFn}
                >
                    {displayCard.map((item, i) => {
                        return <SwiperSlide key={i}>{card(item)}</SwiperSlide>;
                    })}
                    <div className="swiper-button-next"></div>
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-pagination" slot="pagination"></div>
                </Swiper>
                <AuthButton {...props} name="获取您的专属方案" style={{marginTop: '16px'}}/>
            </div>}
        </Fragment>
    );
}
